import { injectable } from "inversify";
import SedeRepository from "../../../../domain/repositories/SedeRepository";
import SedeEntity from "../../../../domain/entities/SedeEntity";
import GetAllSedesApiImpl from "./api/GetAllSedesApiImpl";

@injectable()
class SedeRepositoryImpl implements SedeRepository {
    getAll = (): Promise<SedeEntity[]> => GetAllSedesApiImpl();
}

export default SedeRepositoryImpl;
